// import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { api } from '@/f1/service';
// import md5 from 'md5';
import forge from 'node-forge';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: { cSwitch, Language },
  data : () => {
    return {
      file : undefined,
      confirm: false,
      add: false,
      lock: true,
      model : { hash : '', cause : '' }
    }
  },
  computed: { }, // i18n 메세지 변환용.
  methods: {
    list() { this.$emit('refresh'), this.$router.push({ name: 'wsfinder_hash'}); },
    bs_file(file) {
      try {
        let fr = new FileReader();
        let f = file.target.files[0] ? file.target.files[0] : file.dataTransfer.files[0];
        if(!f) { console.log('no have a file'); return; } else { this.model.cause = f.name; }
        if(f.size > 5242880) { this.$toastr.w(`${i18n_toastr._i18n_warning.file_size[this.i18n]}`); return; }

        fr.onload = async x => { console.log(x);  this.model.hash = await forge.md5.create().update(forge.util.createBuffer(fr.result).data).digest().toHex(); }
        fr.readAsArrayBuffer(f);
      } catch (e) {
        console.log(e)
      }
    },
    async remove() {
      try {
        await api.wsfinder.WSFinder_Call('hash', 'delete', { id : this.model.id })
        //await wf.hash.delete({ id : this.model.id })
        this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`); this.list()
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    },
    async get(id = this.$route.params.id) {
      if (id == 'add' | id == 'edit') { this.lock = false; return; }
      try {
        let rs = await api.wsfinder.WSFinder_Call('hash', 'detail', { id : id })
        //let rs = await wf.hash.detail({ id : id })
        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    async save() {
      if(!(this.model.hash || '').trim()) { return this.$toastr.e(e.data ?`${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText)(`${i18n_toastr._i18n_error.file_selection[this.i18n]}`); }
      try {
        await api.wsfinder.WSFinder_Call('hash', this.model.id ? 'update' : 'insert', this.model);
        
        //let check_id = this.model.id ? `${await wf.hash.update(this.model)}` : `${await wf.hash.update(this.model)}`;
        //let rs = check_id;
        
        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        this.$emit('refresh');
      } catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText) , this.list() }
      this.lock = true;
    },
  },
  watch: { '$route' (to, from) { this.get(to.params.id); } },
  created: function() {   console.log('hash.detail.vue', 'created'); },
  destroyed: function() { console.log('hash.detail.vue', 'destroyed'); },
  mounted: function() { console.log('hash.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}
